module.exports = __webpack_public_path__ + "media/images/display/congratulation-854391799124e289ac090e4c46570424.png";